import React from 'react';
import { Modal, Button, ModalProps, Form, Col } from 'react-bootstrap';
import { createModal } from 'react-modal-promise';
import { Formik, Form as FForm } from 'formik';
import { useTranslation } from 'react-i18next';
import { FlexRow, FormCol, toastWarning } from 'motion-components';
import { SelectYear } from 'shared-pages/pages/idocs/components/select-year';

type Props = {
  open: boolean;
  close: (result: any) => void;
  title: string;
  /** body of dialog */
  text: string | React.ReactNode;
  /** accept text */
  acceptText?: string;
  /** deny text */
  denyText?: string;
  type?: string;
  collectorId?: number;
} & ModalProps;

const ModalInput = ({
  open,
  close,
  title,
  text,
  acceptText = 'OK',
  denyText = 'ΑΚΥΡΩΣΗ',
  type = 'text',
}: Props) => {
  const { t } = useTranslation();
  const handleOk = (values) => {
    if (values.year === '') {
      toastWarning(`${t('Πρέπει να επιλέξετε ένα έτος')}`);
    } else {
      const input = {
        year: values.year,
      };
      close(input);
    }
  };
  return (
    <>
      <Modal size="lg" show={open} centered backdrop="static">
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{ year: 2024 }}
          onSubmit={(values) => {
            handleOk(values);
          }}
        >
          <Form as={FForm}>
            <Modal.Body style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <br />
              <SelectYear
                name="year"
                title={t('Έτος')}
                startYear={2021}
                endYear={new Date().getFullYear() - 1}
                required={true}
              />
            </Modal.Body>
            <Modal.Footer>
              {/*  <Button variant="danger" onClick={() => close(false)}>
            {denyText}
          </Button> */}
              <Button variant="primary" type="submit">
                {t(acceptText)}
              </Button>
              <Button variant="danger" onClick={() => close(false)}>
                {t(denyText)}
              </Button>
            </Modal.Footer>
          </Form>
        </Formik>
      </Modal>
    </>
  );
};

const promiseModalSelectYear = createModal(ModalInput);

export default promiseModalSelectYear;
